import api from './api';

export const verifyUserEmail = (id) => api.put(`/api/v1/actions/verify-email/${id}`);
export const generateAccessCode = (id) => api.post(`/api/v1/actions/generate-access-code/${id}`);
export const uploadPoster = (type, id, formData) =>
  api.post(`/api/v1/actions/upload-poster/${type}/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const uploadBackdrop = (type, id, formData) =>
  api.post(`/api/v1/actions/upload-backdrop/${type}/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
